<template lang="pug">
  .reviews
    .row
      .write-review.sm-12.md-4.lg-4(v-if="canReview")
        a(:href="productReviewUrl", target='_self')
          i.icon-pencil
            span.ada-tooltip pencil icon
          | Write a Review

      .filter
        .xs-12.sm-5.md-4.lg-3
          dropdown(label="Sort By" v-model="sortFilter")
            option(v-for="option in sortFilterOptions" :value="option.value" :key="option.value") {{ option.label }}

    .review-page.row
      Review(v-for="review in reviews" :key="review.id" :review="review").xs-12

    .pagination.row
      template(v-if="page > 1")
        router-link(:to="{ name: 'pdpPage', params: { urlKey: productUrlKey }, query: { reviews: page - 1 }}").back
          i.icon-caret-left
            span.ada-tooltip caret left icon
          span.back-text Back

      span &nbsp;{{ page }}/{{ totalPages }}&nbsp;

      template(v-if="page !== totalPages")
        router-link(:to="{ name: 'pdpPage', params: { urlKey: productUrlKey }, query: { reviews: page + 1 }}").next
          span.next-text Next
          i.icon-caret-right
            span.ada-tooltip caret right icon

</template>

<script>
  import vueReviewSvc from '../../../services/vueReviewSvc';
  import SectionTitle from "../../SectionTitle";
  import Review from "./Review";
  export default {
    name: "Reviews",
    components: {
      Review,
      SectionTitle
    },

    props: {
      productId: {
        type: Number,
        required: true
      },

      productUrlKey: {
        type: String,
        required: true
      },

      sortBy: {
        type:String,
        required: false,
        default: null
      }
    },

    data() {
      return {
        reviews: [],
        page: 1,
        perPage: 5,
        reviewCount: 0,
        reviewSortByConstants: {},
        sortFilter: null,
        canReview: false
      }
    },

    created() {
      vueReviewSvc.getSortByConstants().then(res => {
        this.reviewSortByConstants = res.data;
      });

      vueReviewSvc.canUserReview({ product_id: this.productId }).then(res => {
        this.canReview = res.data.canReview;
      });
    },

    mounted() {
      this.sortFilter = this.sortBy;
      //- check for query review page
      let p = this.$route.query.reviews;
      if (!isNaN(+p)) {
        this.page = p;
      }

      this.getReviews();
    },

    computed: {
      productReviewUrl() {
        return `/product/${this.productUrlKey}/review`;
      },

      sortFilterOptions() {
        return [
          { value: null, label: null },
          { value: this.reviewSortByConstants.NEWEST, label: 'DATE (Recent - Oldest)' },
          { value: this.reviewSortByConstants.OLDEST, label: 'DATE (Oldest - Recent)' },
          { value: this.reviewSortByConstants.HIGHEST, label: 'RATING (Highest - Lowest)' },
          { value: this.reviewSortByConstants.LOWEST, label: 'RATING (Lowest - Highest)' },
          { value: this.reviewSortByConstants.HELPFUL, label: 'MOST HELPFUL' }
        ]
      },

      totalPages() {
        return Math.ceil(this.reviewCount / this.perPage);
      },

      baseUrl() {
        let loc = window.location;
        return loc.protocol + '//' + loc.host + loc.pathname;;
      },

      prevUrl() {
        return this.page === 1 ? '' : this.page === 2 ? this.baseUrl : this.baseUrl + '?reviews=' + (this.page - 1);;
      },

      nextUrl() {
        return this.page < this.totalPages ? this.baseUrl + '?reviews=' + (this.page + 1) : '';
      }
    },

    watch: {
      sortFilter() {
        this.getReviews();
      },
      '$route.query.reviews'() {
        this.page = this.$route.query.reviews;
        this.getReviews();
      }
    },

    methods: {
      getReviews() {
        let payload = {
          product_id: this.productId,
          items_per_page: this.perPage,
          start_page: this.page,
          sort_by: this.sortFilter ? this.sortFilter : this.reviewSortByConstants.HELPFUL
        };

        vueReviewSvc.getProductReviews(payload).then(res => {
          let result = res.data;
          this.reviews = result.reviews;
          this.page = result.page;
          this.reviewCount = result.total_count;
          this.handlePaginationSEO();
        });
      },

      handlePaginationSEO() {
        let thisUrl = this.baseUrl;

        if (this.page !== 1) {
          thisUrl += '?reviews=' + this.page;
        }

        $('link[rel=canonical]').attr('href', thisUrl);

        let prevLink = $('link[rel=prev]');

        if (this.prevUrl) {
          if (prevLink.length) {
            prevLink.attr('href', this.prevUrl);
          } else {
            $('head').append('<link rel="prev" href="' + this.prevUrl + '" />');
          }
        } else if (prevLink.length) {
          prevLink.remove();
        }

        let nextLink = $('link[rel=next]');
        if (this.nextUrl) {
          if (nextLink.length) {
            nextLink.attr('href', this.nextUrl);
          } else {
            $('head').append('<link rel="next" href="' + this.nextUrl + '" />');
          }
        } else {
          nextLink.remove();
        }
      }
    }

  }
</script>

<style scoped lang="stylus">
  .reviews
    padding 1em 2em
    margin-bottom 1em

    .write-review
      display inline-block
      width 29%
      vertical-align top

    .review-page
      margin 2em 0 1em

    .pagination
      position relative
      text-align right
      margin-top 20px
      margin-right 20px
      margin 20px 20px 0 0

      a
        position relative
        text-decoration underline
        text-transform capitalize

        &.back
          margin-right 20px
        &.next
          margin-left 20px

        .next-text
          margin-right 3px
          pading-right 20px

        .back-text
          margin-left 3px

        i
          font-size 9px

          &.icon-caret-right
            position absolute
            right -15px
            top 2px

          &.icon-caret-left
            position absolute
            left -15px
            top 2px

    @media mq-mobile
      .write-review
        width 100%

</style>